module.exports = __webpack_public_path__ + "static/eth-00b506b2d45e46d80f46c84e2bf3d2b9.png";